// Minimal Jest stub for transitive react-form-builder imports.
// Device-management tests do not exercise smartfield-ui runtime behavior.
export const SmartFieldUI = () => null;

const smartFieldUiMock = {};

export default smartFieldUiMock;
